import { useEffect, useState } from "react";
import { Category } from "../../../entity/Entity";
import { GetCategories, AddCategory, DelCategory } from "../../../api/requests/Api";
import "./AdminCategory.css";
import MenuAdmin from "../menu/MenuAdmin";
import ImageUploader from "../../../utils/ImgDownloader";

const emptyCategory: Category = {
    _id: "",
    name: "",
    image_link: "",
};

const AdminCategory = () => {
    const [categories, setCategories] = useState<Category[]>([]);
    const [currentCategory, setCurrentCategory] = useState<Category>(emptyCategory);
    const [loading, setLoading] = useState<boolean>(true);
    const [message, setMessage] = useState<string | null>(null);

    useEffect(() => {
        loadCategories();
    }, []);

    const loadCategories = async () => {
        try {
            setLoading(true);
            const data = await GetCategories();
            setCategories(data);
        } catch {
            setMessage("Failed to load categories");
        } finally {
            setLoading(false);
        }
    };

    const handleSaveCategory = async () => {
        if (!currentCategory.name.trim() || !currentCategory.image_link.trim()) {
            setMessage("Name and image link are required");
            return;
        }

        try {
            await AddCategory(currentCategory as any);
            setMessage(currentCategory._id ? "Category updated" : "Category added");
            setCurrentCategory(emptyCategory);
            loadCategories();
        } catch {
            setMessage("Failed to save category");
        }
    };

    const handleEditCategory = (category: Category) => {
        setCurrentCategory({ ...category });
    };

    const handleDeleteCategory = async (id: string) => {
        try {
            await DelCategory(id);
            setMessage("Category deleted");
            loadCategories();
        } catch {
            setMessage("Failed to delete category");
        }
    };

    const cancelEdit = () => {
        setCurrentCategory(emptyCategory);
    };

    if (loading) {
        return <div className="admin-category-loading">Загрузка...</div>;
    }

    return (
        <div className="admin-category-page">
            <MenuAdmin />
            <h1 className="admin-category-title">Categories Management</h1>

            {message && <div className="admin-category-message">{message}</div>}

            {/* FORM */}
            <div className="admin-category-form">
                <h2>{currentCategory._id ? "Edit Category" : "Add New Category"}</h2>

                <ImageUploader />

                <div className="admin-category-field">
                    <label>Name</label>
                    <input
                        type="text"
                        value={currentCategory.name}
                        onChange={(e) =>
                            setCurrentCategory({
                                ...currentCategory,
                                name: e.target.value,
                            })
                        }
                        placeholder="Category name"
                    />
                </div>

                <div className="admin-category-field">
                    <label>Image Link</label>
                    <input
                        type="text"
                        value={currentCategory.image_link}
                        onChange={(e) =>
                            setCurrentCategory({
                                ...currentCategory,
                                image_link: e.target.value,
                            })
                        }
                        placeholder="https://example.com/image.jpg"
                    />
                </div>

                <div className="admin-category-actions">
                    <button onClick={handleSaveCategory}>
                        {currentCategory._id ? "Update Category" : "Add Category"}
                    </button>

                    {currentCategory._id && (
                        <button
                            className="secondary"
                            onClick={cancelEdit}
                        >
                            Cancel
                        </button>
                    )}
                </div>
            </div>

            {/* LIST */}
            <div className="admin-category-list">
                <h2>Existing Categories</h2>

                {categories.length === 0 && (
                    <div className="admin-category-empty">No categories</div>
                )}

                {categories.map((cat) => (
                    <div key={cat._id} className="admin-category-item">
                        <div className="admin-category-info">
                            <img
                                src={cat.image_link}
                                alt={cat.name}
                                className="admin-category-image"
                            />
                            <div className="admin-category-name">{cat.name}</div>
                        </div>

                        <div className="admin-category-actions">
                            <button onClick={() => handleEditCategory(cat)}>
                                Edit
                            </button>
                            <button
                                className="danger"
                                onClick={() => handleDeleteCategory(cat._id)}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminCategory;
